// extracted by mini-css-extract-plugin
module.exports = {"Caption":"Loading_Caption__32zmQ"};